import DOMPurify from 'dompurify';
import { convertImgPlaceholders } from '../../services/sanitizeHTML';

const allowedTags = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  'ul',
  'ol',
  'li',
  'h2',
  'h3',
  'a',
  'img',
];

export function sanitizeFaqEditorHtml(html: string): string {
  const clean = DOMPurify.sanitize(convertImgPlaceholders(html), {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: ['href', 'src', 'alt'],
  });
  const wrapper = document.createElement('div');
  wrapper.innerHTML = clean;

  wrapper.querySelectorAll('a').forEach((anchor) => {
    const href = anchor.getAttribute('href') || '';
    if (!/^https:\/\//i.test(href)) anchor.replaceWith(...Array.from(anchor.childNodes));
    else anchor.setAttribute('rel', 'noopener noreferrer');
  });
  wrapper.querySelectorAll('img').forEach((image) => {
    const src = image.getAttribute('src') || '';
    if (!((src.startsWith('/assets/') || src.startsWith('/api/images/')) && !src.includes('..'))) {
      image.remove();
    }
  });
  return wrapper.innerHTML;
}
